import {gql} from '@apollo/client';

export const mediaFilesMutations = {
    STORE_MEDIA_FILES: gql`
        mutation storeMediaFiles($files: [Upload!]!, $objectType: String!, $objectId: UUID!) {
            storeMediaFiles(files: $files, objectType: $objectType, objectId: $objectId) {
                id
                fileName
                partialFilePath
            }
        }
    `,
    DELETE_MEDIA_FILES_BY_IDS: gql`
        mutation deleteMediaFilesByIds($ids: [UUID!]!) {
            deleteMediaFilesByIds(ids: $ids) {
                statusCode
                success
                message
                data
            }
        }
    `,
    DELETE_MEDIA_FILES_BY_OBJECT_ID_AND_OBJECT_TYPE: gql`
        mutation deleteMediaFilesByObjectIdAndObjectType($objectId: UUID!, $objectType: String!) {
            deleteMediaFilesByObjectIdAndObjectType(objectId: $objectId, objectType: $objectType) {
                statusCode
                success
                message
                data
            }
        }
    `,
};
